import { render, staticRenderFns } from "./ConfirmDocsModal.vue?vue&type=template&id=d9b282ee&"
import script from "./ConfirmDocsModal.vue?vue&type=script&lang=js&"
export * from "./ConfirmDocsModal.vue?vue&type=script&lang=js&"
import style0 from "./ConfirmDocsModal.vue?vue&type=style&index=0&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports